import { useState, useEffect, useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb, { getCategoryName } from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'wanfa-guize');

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
    }
  }, [slug]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [activeSlug]);

  const filteredArticles = useMemo(() => {
    return articles.filter((a) => a.category === activeSlug);
  }, [activeSlug]);

  const currentCategory = categories.find((c) => c.slug === activeSlug);
  const categoryName = currentCategory?.name || activeSlug;

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 pb-14">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', to: '/' },
              { label: categoryName },
            ]}
          />

          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              {categoryName}
            </h1>
            {currentCategory && (
              <p className="text-sm text-foreground-600 mt-2">
                {currentCategory.description}
              </p>
            )}
          </div>

          <div className="flex gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={() => setActiveSlug(cat.slug)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeSlug === cat.slug
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200 border border-background-200/70'
                }`}
              >
                <i className={`${cat.icon} mr-1.5`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          {filteredArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {filteredArticles.map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-100">
                <i className="ri-file-list-3-line text-2xl text-secondary-500"></i>
              </div>
              <p className="text-foreground-600">该分类暂无文章</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}